export default "__VITE_ASSET__psXVHwyl__"